import React, { useEffect, useState } from 'react';
import { brand, nav } from '../mock/data';
import { Menu, X } from 'lucide-react';
import Countdown from './Countdown';
import { useNotify } from './Notify';

const RollLink = ({ label, href, onClick }) => (
  <a href={href} onClick={onClick} className="roll-link text-[13px] uppercase tracking-[0.14em] text-[var(--ink)]">
    <span className="roll-inner">
      <span>{label}</span>
      <span aria-hidden="true" className="text-[var(--accent)]">{label}</span>
    </span>
  </a>
);

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { open: openNotify } = useNotify();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-9 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled ? 'bg-white/85 backdrop-blur-md border-b border-[var(--line)]' : 'bg-transparent'
        }`}
      >
        <div className="max-frame container-px flex items-center justify-between h-[68px]">
          <a href="#top" className="flex items-center gap-2.5">
            <img src={brand.marks.lotus} alt="Lotus" className="h-7 w-auto" />
            <span className="font-display text-xl leading-none tracking-wide">PL16</span>
          </a>

          <nav className="hidden md:flex items-center gap-9">
            {nav.map((n) => <RollLink key={n.label} {...n} />)}
          </nav>

          <div className="hidden md:flex items-center gap-6">
            <Countdown compact className="hidden lg:flex" />
            <button onClick={() => openNotify('navbar')} className="btn-primary inline-flex px-5 py-2.5 text-[12px] uppercase tracking-[0.12em]">
              Notify Me
            </button>
          </div>

          <button className="md:hidden text-[var(--ink)]" onClick={() => setOpen(true)} aria-label="Open menu">
            <Menu size={24} />
          </button>
        </div>
      </header>

      {/* Mobile sheet */}
      <div
        className={`fixed inset-0 z-[80] bg-white transition-opacity duration-400 md:hidden ${
          open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="container-px flex items-center justify-between h-[68px]">
          <div className="flex items-center gap-2.5">
            <img src={brand.marks.lotus} alt="Lotus" className="h-7 w-auto" />
            <span className="font-display text-xl tracking-wide">PL16</span>
          </div>
          <button onClick={() => setOpen(false)} aria-label="Close menu"><X size={26} /></button>
        </div>
        <nav className="container-px mt-12 flex flex-col gap-7">
          {nav.map((n) => (
            <a key={n.label} href={n.href} onClick={() => setOpen(false)} className="font-display uppercase text-4xl text-[var(--ink)]">
              {n.label}
            </a>
          ))}
          <a href={brand.dealsUrl} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} className="btn-primary mt-4 px-6 py-3.5 text-center text-[13px] uppercase tracking-[0.12em]">
            Get the Lotus Bundle
          </a>
        </nav>
      </div>
    </>
  );
};

export default Navbar;
